import { IContaProduto } from "../../../Interfaces/Cobranca/ContaProduto/ContaProdutoInterface";
import {
    ListarProdutosPorContaAdimplenciaService,
    ListarProdutosPorContaAdimplentesService,
    ListarProdutosPorContaService,
    VerificaInadimplenciaProdutoService,
    VerificaPossibilidadeCobrancaPorAtendimentoService,
    VerificaProdutoAdimplenteService,
    VerificarPossibilidadeCobrancaPorProdutoService,
} from "../../../Services/Cobranca/ProdutoConta/ProdutoContaServices";
import { groupBy } from "../../../Tools/ProcessingTools";
import { Controller } from "../../Controller";

export async function ListarProdutosPorContaController(
    idConta: number,
    idTipoCaso: number
) {
    const ListarProdutosPorContaPromise = Controller(
        ListarProdutosPorContaService(idConta, idTipoCaso)
    );
    const ListarProdutosPorContaAdimplentesPromise = Controller(
        ListarProdutosPorContaAdimplentesService(idConta, idTipoCaso)
    );
    return Promise.all([
        ListarProdutosPorContaPromise,
        ListarProdutosPorContaAdimplentesPromise,
    ]).then(([ProdutosConta, ProdutosComAdimplencia]) => {
        // agrupa os produtos por id_unidade e, de cada grupo, pega o primeiro, com preferência para pegar as vendas ativas
        // isso é feito pra eliminar produtos com id repetido ( isso não deveria acontecer a princípio )
        const produtosSemRepeticao = Array.from(
            groupBy(ProdutosConta, (p) => String(p.UNIDADE.ID_UNIDADE)).values()
        ).map(
            (ps) =>
                ps.sort(
                    (p1, p2) =>
                        (p2.UNIDADE.FL_STATUS_VENDA ? 1 : 0) -
                        (p1.UNIDADE.FL_STATUS_VENDA ? 1 : 0)
                )[0]
        );
        // faz um left join entre produtosconta(sem repeticao) e produtosComAdimplencia
        // necessário pois o segundo sempre traz os produtos com venda inativa
        return produtosSemRepeticao.map((pc) => {
            const pa = ProdutosComAdimplencia.find(
                (pa) =>
                    pc.UNIDADE.ID_UNIDADE === pa.ID_UNIDADE &&
                    pc.UNIDADE.ID_CHAVE_ERP_VENDA === pa.ID_CHAVE_ERP
            );
            return {
                ...pc,
                UNIDADE: {
                    ...pc.UNIDADE,
                    FL_DIVIDA: pa?.FL_DIVIDA || false,
                    ID_CHAVE_ERP_VENDA: pa?.ID_CHAVE_ERP || "",
                    ID_CONTA_PRODUTO: pa?.ID_CONTA_PRODUTO,
                },
                DS_STATUS_ESCRITURA: ProdutosConta.filter(
                    (pr) =>
                        pr.ID_EMPREENDIMENTO === pc.ID_EMPREENDIMENTO &&
                        pr.UNIDADE.ID_UNIDADE === pc.UNIDADE.ID_UNIDADE
                )
                    .map((x) => x.DS_STATUS_ESCRITURA)
                    .join(","),
            } as IContaProduto;
        });
    });
}

export async function ListarProdutosPorContaAdimplenciaController(
    idConta: number
) {
    return Controller(ListarProdutosPorContaAdimplenciaService(idConta));
}

export async function VerificaProdutoAdimplenteController(idChaveERP: string) {
    return Controller(VerificaProdutoAdimplenteService(idChaveERP));
}

export async function VerificarPossibilidadeCobrancaPorProdutoController(
    idProdutos: Array<number>
) {
    return Controller(
        VerificarPossibilidadeCobrancaPorProdutoService(idProdutos)
    );
}

export async function VerificaPossibilidadeCobrancaPorAtendimentoController(
    idCaso: number
) {
    return Controller(
        VerificaPossibilidadeCobrancaPorAtendimentoService(idCaso)
    );
}

export async function ListarProdutosPorContaCompleto(
    idConta: number,
    idTipoCaso: number
) {
    return Controller(ListarProdutosPorContaService(idConta, idTipoCaso));
}

export async function VerificaInadimplenciaProdutoController(
    ID_CHAVE_ERP: string
) {
    return Controller(VerificaInadimplenciaProdutoService(ID_CHAVE_ERP));
}
